import { Box, CircularProgress, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { COLOR_FROM_CLASSIFICATION, ICON_FROM_CLASSIFICATION } from "library/SFG20/constants.mjs"
import { CostFigure } from "./cost-figure"

export function CostCriticalitySummaryItem({ item, currencySymbol }) {
    const color = COLOR_FROM_CLASSIFICATION[item.classification] || "#9E9E9E"
    const icon = ICON_FROM_CLASSIFICATION[item.classification]
    const taskCount = item.taskCount || 0
    const totalCost = item.totalCost || 0

    return (
        <Stack
            data-cy={`criticality-summary-${item.classification}`}
            alignItems="center"
            spacing={1}
            sx={{ flex: 1, minWidth: 0 }}
        >
            <Stack alignItems="center" justifyContent="center" sx={{ position: "relative" }}>
                <CircularProgress
                    variant="determinate"
                    value={100}
                    size={56}
                    thickness={4}
                    sx={{ color: "grey.50016", opacity: 0.48 }}
                />
                <CircularProgress
                    variant="determinate"
                    value={Math.min(item.percentage || 0, 100)}
                    size={56}
                    thickness={4}
                    sx={{ color, position: "absolute", top: 0, left: 0 }}
                />
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Iconify icon={icon} sx={{ color, width: 22, height: 22 }} />
                </Box>
            </Stack>
            <CostFigure
                value={totalCost}
                currencySymbol={currencySymbol}
                variant="subtitle1"
                fontWeight={700}
                sx={{ fontSize: "18px" }}
            />
            <Typography variant="body2" color="text.secondary" noWrap sx={{ fontWeight: 500 }}>
                <Box component="span" sx={{ fontWeight: 700 }}>
                    {taskCount}
                </Box>{" "}
                {item.classification} {taskCount === 1 ? "Task" : "Tasks"}
            </Typography>
        </Stack>
    )
}
